let DTODAVZ1 = {
  //取得推薦序號
  getSno: "/api/DTODAVZ1/getSno",
  //取得名額
  getQuota: "/api/DTODAVZ1/getQuota",
  //取得活動資格
  getQual: "/api/DTODAVZ1/getQual",
  //確認是否登入
  checkLogin: "/api/DTODAVZ1/checkLogin"
};
export default DTODAVZ1;
